import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Modal,Select,Radio, TimePicker,Image,Progress,InputNumber,Space } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import UploadFile from '../../components/UploadFile';
import {api_tenant_add, api_tenant_edit, api_testemail} from '../../../api';
import moment from 'moment';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

const { TextArea } = Input;
const { Option } = Select;
const screenHeight = document.body.clientHeight;
let followOptions={follow:[], follow_email:[], follow_phone:[]};

const App =(props)=>{
    const {showModal, closeModal, rowInfo, refreshlist, showEditMicrosoft} = props;
    console.log('1111111111111111111111111111111111111-', rowInfo)
    const [form] = Form.useForm();
    const [loading,setLoading] = useState(false);
    const [testLoading,setTestLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [attpercent, setAttpercent] = useState(0);
    const [attpercentShow,setAttpercentShow] = useState(false);
    const [imageUrl2, setImageUrl2] = useState("");
    const [attpercent2, setAttpercent2] = useState(0);
    const [attpercentShow2,setAttpercentShow2] = useState(false);
    const [showMicrosoft,setShowMicrosoft] = useState(false);
    const [emailOk,setEmailOk] = useState(false);
    // const [microsortOk,setMicrosortOk] = useState(false);

    useEffect(() => {
      if(showModal){
        if(rowInfo.tenant_id == undefined){
          form.resetFields();
          setImageUrl("");
          setImageUrl2("");
        } else {
          for (let key in rowInfo) {
            if(key=='work_time'){
              if(rowInfo[key]){
                form.setFieldValue(key, [moment(rowInfo[key][0],"HH:mm"), moment(rowInfo[key][1],"HH:mm")] )
              }
            }
            else
              form.setFieldValue(key, rowInfo[key])
          }
          // if(rowInfo['is_outlook_enabled'] == '1')
          //   setShowMicrosoft(true);
          // else
          //   setShowMicrosoft(false);
          setImageUrl(rowInfo.licence);
          setImageUrl2(rowInfo.orgcode);
        }
      }else{
        form.resetFields();
        setLoading(false);
        setTestLoading(false);
        setImageUrl("");
        setImageUrl2("");
        setAttpercent(0);
        setAttpercentShow(false);
        // setShowMicrosoft(false);
        setEmailOk(false);
      }
    }, [showModal]);

    useEffect(() => {
      form.setFieldValue("licence", imageUrl);
    }, [imageUrl]);

    useEffect(() => {
      form.setFieldValue("orgcode", imageUrl2);
    }, [imageUrl2]);

    // const mockVal = (str, repeat = 1) => ({
    //   value: str.repeat(repeat),
    // });
    
    // const onSearch = (searchText) => {
    //   setOptions(
    //     !searchText ? [] : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)],
    //   );
    // };
    // const onSelect = (data) => {
    //   console.log('onSelect', data);
    // };
    const onChangeMicrosoft = (e) => {
      console.log(e);
      if(e.target.value=='1')
        setShowMicrosoft(true);
      else
        setShowMicrosoft(false);
    };

    const setOptions = async(key, value)=>{
      if(value){
        for(let item of followOptions[key]){
          if(item.value == value)
            return;
        }
        followOptions[key].push({value:value});
      }
    };

    const sendTestmail = async()=>{
      var email = form.getFieldValue("email");
      console.log(email);
      if(!email['sendServer'] || !email['username'] || !email['password'] || !email['sendPort'] || !email['authSSL']){
        message.warn("请输入邮箱参数");
        return false;
      }

      setTestLoading(true);
      try {
        await api_testemail({email:email}).then((res) => {
          setTestLoading(false);
          console.log('api_testemail-res-----------------', res);
          if (res.data.code == 9) {
            // message.success("发送成功，请检查邮箱");
            Modal.confirm({
              title: '邮件确认',
              content: '发送成功，请检查本账号邮箱是否收到邮件',
              okText: '收到',
              cancelText: '未收到',
              onCancel() {
                setEmailOk(false);
              },
              onOk() {
                setEmailOk(true);
              },
            });
          }else{
            message.error(res.data.msg);
            setEmailOk(false);
          }
        });
        } catch (error) {
          message.error("其他异常-"+error);
          setTestLoading(false);
          setEmailOk(false);
          return false;
        }
    }

    const onFinish = async(value)=>{
      console.log(value);

      if(!emailOk){
        message.warn("请先测试办公邮箱设置是否正确");
        return false;
      }

      if(value.is_outlook_enabled=='1' && !value.microsort){
        message.warn("请输入微软配置");
        return false;
      }
      if(value.work_time){
        const [start2, end2] = value.work_time;
        const noon_stime = start2 ? moment(start2).format('HH:mm') : null;
        const noon_etime = end2 ? moment(end2).format('HH:mm') : null;
        console.log('开始时间:', noon_stime);
        console.log('结束时间:', noon_etime);
        value.work_time = [noon_stime, noon_etime];
      }

      value.tenant_id = rowInfo.tenant_id;
      var fun = rowInfo.tenant_id ? api_tenant_edit : api_tenant_add;

      setLoading(true);
      try {
        await fun(value).then((res) => {
          setLoading(false);
          console.log(fun+'-res-----------------', res);
          if (res.data.code == 9) {
            if(rowInfo.tenant_id)
              message.success("操作成功");
            else
              showEditMicrosoft({tenant_id: res.data.tenant_id})
              // message.success("新增租户成功，如已开通微软授权请前往配置");
            closeModal();
            refreshlist();
          }else
            message.error(res.data.msg);
        });
        } catch (error) {
          message.error("网络异常");
          setLoading(false);
          return false;
        }
  }

    //发布(字段没填写完整)
    const onFinishFailed = async (e) => {
    // console.log(e.errorFields[0].name)
        // form.scrollToField(e.errorFields[0].name) // 滚动到对应字段位置
      setTimeout(()=>{
          document.querySelector('.ant-form-item-has-error')?.scrollIntoView({behavior: 'smooth', block: 'center'});
      }, 100)
  }

  return (
    <Modal 
        key="tenantinfo"
        title={(rowInfo.tenant_id ? '编辑' :'新增')+"租户"}
        open={showModal}
        width={"70%"}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        {rowInfo.tenant_id?"确认":"下一步"}
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="horizontal"
            autoComplete="off"
            labelAlign="left"
            labelCol={{span:5}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{
              is_outlook_enabled:"0",
              work_time:[moment("9:00","HH:mm"), moment("18:00","HH:mm")],
              time_interval:2,
              email:{sendPort:465,authSSL:"1"},
              microsort:{azureCloudUrl:2},
              status:'1',
            }}
        >
            <Form.Item
                label="租户名称"
                name="tenant_name"
                rules={[
                  {required: true, message: '请输入租户名称',},
                ]}
            >
            <Input />
            {/* <Input disabled={rowInfo.tenant_id?true:false} /> */}
            </Form.Item>
            <Form.Item
                label="租户英文名称"
                name="english_name"
                // rules={[
                //   {required: true, message: '请输入租户英文名称',},
                // ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="营业执照"
                name="licence"
                // rules={[
                //   {required: true, message: '请上传公司logo',},
                // ]}
            >
              <UploadFile 
                from = {"A"}
                upButton = {<Button type="primary" style={{marginRight:20}}>上传</Button>}
                uploadFileType = {".png, .jpg, .jpeg, .gif"}
                uploadFileSize = {2*1024*1024}
                setpercent = {setAttpercent}
                setPercentShow = {setAttpercentShow}
                setFileUrl = {setImageUrl}
              />
              {imageUrl ? 
                <Image
                  height={50}
                  src={imageUrl}
                /> : ""
              }
              <Progress percent={attpercent} strokeWidth={6} style={{top:5,display:attpercentShow?'block':'none'}}/>

            </Form.Item>
            <Form.Item
                label="组织机构代码"
                name="orgcode"
                // rules={[
                //   {required: true, message: '请上传公司logo',},
                // ]}
            >
              <UploadFile 
                from = {"A"}
                upButton = {<Button  type="primary" style={{marginRight:20}}>上传</Button>}
                uploadFileType = {".png, .jpg, .jpeg, .gif"}
                uploadFileSize = {2*1024*1024}
                setpercent = {setAttpercent2}
                setPercentShow = {setAttpercentShow2}
                setFileUrl = {setImageUrl2}
              />
              {imageUrl2 ? 
                <Image
                  height={50}
                  src={imageUrl2}
                /> : ""
              }
              <Progress percent={attpercent2} strokeWidth={6} style={{top:5,display:attpercentShow2?'block':'none'}}/>

            </Form.Item>
            <Form.Item
                label="公司地址"
                name="address"
                rules={[
                  {required: true, message: '请输入公司地址',},
                ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="上下班时间"
                name="work_time"
                // rules={[
                //   {required: true, message: '请输入租户名称',},
                // ]}
            >
              <TimePicker.RangePicker
                showTime={{ format: 'HH:mm' }}
                format="HH:mm"
                // defaultValue={defaultTimeRange}
                placeholder={['开始时间', '结束时间']}
                allowClear={false}
              />
            </Form.Item>
            <Form.Item
              label="时间间隔"
                name="time_interval"
                rules={[
                  {required: true, message: '请输入时间间隔',},
                ]}
                extra={<div style={{color:'green',fontSize:'12px',lineHeight: '20px',paddingTop:10,width:"100%",textAlign:"left"}}>*执行时间与可用面试时间间隔(单位：小时)</div>}
            >
              <InputNumber min={2} />
            </Form.Item>
            <Form.Item
                label="办公邮箱"
                name="email"
            >
              <Button type="primary" loading={testLoading} style={{marginBottom:20}} onClick={sendTestmail} disabled={emailOk?true:false}>测试</Button>
              <Form.Item
                  label="sendServer"
                  name={['email', 'sendServer']}
                  labelCol={{span:5}}
                  rules={[
                    {required: true, message: '请输入sendServer',},
                  ]}
              >
              <Input disabled={emailOk?true:false} />
              </Form.Item>
              <Form.Item
                  label="username"
                  name={['email', 'username']}
                  labelCol={{span:5}}
                  rules={[
                    {required: true, message: '请输入username',},
                    {
                      type: 'email',
                      message: '请输入有效的邮箱地址',
                    },
                  ]}
              >
              <Input disabled={emailOk?true:false} />
              </Form.Item>
              <Form.Item
                  label="password"
                  name={['email', 'password']}
                  labelCol={{span:5}}
                  rules={[
                    {required: true, message: '请输入password',},
                  ]}
              >
              <Input disabled={emailOk?true:false} />
              </Form.Item>
              <Form.Item
                  label="sendPort"
                  name={['email', 'sendPort']}
                  labelCol={{span:5}}
                  rules={[
                    {required: true, message: '请输入sendPort',},
                  ]}
              >
              <InputNumber min={1} disabled={emailOk?true:false} />
              </Form.Item>
              <Form.Item
                  label="authSSL"
                  name={['email', 'authSSL']}
                  labelCol={{span:5}}
                  rules={[
                    {required: true, message: '请输入authSSL',},
                  ]}
              >
                <Select disabled={emailOk?true:false}>
                  <Option value="1">TRUE</Option>
                  <Option value="0">FALSE</Option>
              </Select>
              </Form.Item>

            </Form.Item>

            {/* <Form.Item
                label="开通微软授权"
                name="is_outlook_enabled"
                style={{display:rowInfo.tenant_id?"":"none"}}
            >
              <Radio.Group style={{width:"80%"}} onChange={onChangeMicrosoft}>
                <Space size={10}>
                <Radio value={"0"}>未开通</Radio>
                <Radio value={"1"}>已开通</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.Item
                label="微软配置"
                name="microsort"
                style={{display:rowInfo.tenant_id && showMicrosoft?"":"none"}}
            >
              <Button type="primary" style={{marginBottom:20}}>测试</Button>
              <Form.Item
                  label="clientId"
                  name={['microsort', 'clientId']}
                  labelCol={{span:5}}
              >
              <Input />
              </Form.Item>
              <Form.Item
                  label="tenantId"
                  name={['microsort', 'tenantId']}
                  labelCol={{span:5}}
              >
              <Input />
              </Form.Item>
              <Form.Item
                  label="clientSecret"
                  name={['microsort', 'clientSecret']}
                  labelCol={{span:5}}
              >
              <Input />
              </Form.Item>
              <Form.Item
                  label="azureCloudUrl"
                  name={['microsort', 'azureCloudUrl']}
                  labelCol={{span:5}}
              >
              <Select>
                  <Option value={2}>中国</Option>
                  <Option value={1}>国际</Option>
              </Select>

              </Form.Item>
            </Form.Item> */}

            <Form.Item
                label="短信通道号"
                name="sms_channel_number"
            >
              <Input />
            </Form.Item>
            <Form.Item
                label="其他信息"
                name="remark"
            >
            <TextArea rows={4} placeholder="最多200个字" maxLength={200} />
            </Form.Item>
            <Form.Item
                label="租户状态"
                name="status"
            >
              <Radio.Group style={{width:"80%"}}  >
                <Space size={10}>
                <Radio value={"1"}>激活</Radio>
                <Radio value={"0"}>停用</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

        </Form>
        </Modal>
  )
}
export default App
